import { render, staticRenderFns } from "./salesOrderTemplate.vue?vue&type=template&id=6ec16ef4"
import script from "./salesOrderTemplate.vue?vue&type=script&lang=js"
export * from "./salesOrderTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports